export const LocalStorageKeys = {
    user_id:'USER_ID',
    token:'TOKEN',
    type:'USER_TYPE',
    credential:'CREDENTIAL',
    spotify_token:'SPOTIFY_TOKEN'
}